<template src="./PartnerPlans.html"></template>
<script>
import moment from "moment";
import mixins from "../../../../../Mixins.js";
import WholeMultiselect from "@/components/whole-multiselect/WholeMultiselect.vue";
export default {
  mixins: [mixins],
  components: { WholeMultiselect },
  data() {
    return {
      planTypeSelected: null,
      plan: {},
      checaEditando: true,
      status: null,
      active: null,
      name: null,
      description: null,
      initialDate: null,
      finalDate: null,
      planValue: null,
      code: null,
      planIdIugu: null,
      companyId: null,
      company: null,
      planPackage: null,
      planPackages: null,
      servicesAssociated: [],
      additionalLifeValue: null,
      isCombo: false,
      period: null,
      method: null,
      planTypeId: null,
      planType: null,
      discount: null,
      options: null,
      multPlanCode: null,
      rootCampaign: null,
      businessType: null,
      initialDateFormated: null,
      finalDateFormated: null,
      disabledRadioB2C: false,
      disabledRadioB2B: true,
      showRowTypeCampaign: false,
      isDefaultPlan: false,
      freetrial: false,
      amountDaysFreetrial: null,
      plansType: [
        { id: 1, description: "Plano individual" },
        { id: 2, description: "Plano plus" },
        { id: 3, description: "Plano por código" },
      ],
      titlePopupPlans: "",
      showPagePlan: false,
      showlistPlans: true,
      plans: [],
      plansPaginated: [],
      companies: [],
      periods: [
        { value: "mensais", text: "Mensal" },
        { value: "semestrais", text: "Semestral" },
        { value: "anuais", text: "Anual" },
      ],
      methods: [
        { value: "boleto", text: "Boleto bancário" },
        { value: "cartao", text: "Cartão de crédito" },
        { value: "todos", text: "Todos (Boleto e Cartão de crédito)" },
      ],
      invalidFields: {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        planValue: false,
        code: false,
        planTypeId: false,
        businessType: false,
        planIdIugu: false,
        companyId: false,
        period: false,
        method: false,
        discount: false,
        options: false,
        rootCampaign: false,
        multPlanCode: false,
        additionalLifeValue: false,
        planPackage: false,
        amountDaysFreetrial: false,
      },
      saveClicked: false,
      currentx: 1,
      numPages: 0,
      pagination: false,
      windowWidth: 0,
      plansHistoric: [],
    };
  },
  watch: {
    name: function (newVal) {
      const vm = this;
      vm.invalidFields.name =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    description: function (newVal) {
      const vm = this;
      vm.invalidFields.description =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    initialDateFormated: function () {
      const vm = this;
      if (vm.saveClicked) vm.validateDates();
    },
    finalDateFormated: function () {
      const vm = this;
      if (vm.saveClicked) vm.validateDates();
    },
    code: function (newVal) {
      const vm = this;
      vm.invalidFields.code =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planValue: function (newVal) {
      let vm = this;
      vm.invalidFields.planValue =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    businessType: function (newVal) {
      const vm = this;
      vm.invalidFields.businessType =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    period: function (newVal) {
      const vm = this;
      vm.invalidFields.period =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    method: function (newVal) {
      const vm = this;
      vm.invalidFields.method =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    rootCampaign: function (newVal) {
      const vm = this;
      vm.invalidFields.rootCampaign =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    discount: function (newVal) {
      const vm = this;
      vm.invalidFields.discount =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    options: function (newVal) {
      const vm = this;
      vm.invalidFields.options =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    company: function (newVal) {
      const vm = this;
      vm.invalidFields.companyId =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
      vm.companyId = vm.invalidFields.companyId ? null : newVal.id;
    },
    planType: function (newVal) {
      const vm = this;
      vm.invalidFields.planTypeId =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
      vm.planTypeId = vm.invalidFields.planTypeId ? null : newVal.id;
      vm.isMultiple = vm.planTypeId === 3 ? true : vm.isMultiple;
    },
    planIdIugu: function (newVal) {
      const vm = this;
      vm.invalidFields.planIdIugu =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    multPlanCode: function (newVal) {
      const vm = this;
      vm.invalidFields.multPlanCode =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    planPackage: function (newVal) {
      let vm = this;
      vm.invalidFields.planPackage = newVal === null || newVal === [];
    },
    freetrial: function (newVal) {
      const vm = this;
      vm.invalidFields.freetrial =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    amountDaysFreetrial: function (newVal) {
      const vm = this;
      vm.invalidFields.amountDaysFreetrial =
        vm.testNullUndefinedEmpty(newVal) && vm.saveClicked;
    },
    currentx: function () {
      const vm = this;
      vm.changePagination();
    },
  },
  mounted: function () {
    const vm = this;
    vm.init();
  },
  created() {
    const vm = this;
    window.addEventListener("resize", vm.handleResize);
    vm.handleResize();
  },
  destroyed() {
    const vm = this;
    window.removeEventListener("resize", vm.handleResize);
  },
  methods: {
    init() {
      const vm = this;

      if (vm.$route.params) {
        vm.partner = vm.$route.params.id;
      }

      vm.getPlans();
      vm.getTypePlans();
      vm.getCompaniesRegistered();
      vm.getPlanPackages();
    },
    removePlan(id) {
      const vm = this;
      vm.axios
        .delete(vm.$store.state.filooServer + "customerplan/" + id, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.$vs.notify({
              title: "Sucesso!",
              text: "O plano Foi removido com sucesso!",
              color: "success",
              icon: "verified_user",
              position: "top-right",
            });
            vm.getPlans();
          }
        });
    },
    goToPlanList() {
      const vm = this;
      vm.showPagePlan = false;
      vm.showlistPlans = true;
    },
    getCompaniesRegistered() {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer +
            "admin/companies?page=0&size=50&sort=id,desc",
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status == 200) {
            vm.companies = response.data.content;
          }
        });
    },
    getTypePlans() {
      const vm = this;
      vm.axios.defaults.headers.common["Authorization"] =
        vm.$session.get("bearerDefault");
      vm.axios
        .get(vm.$store.state.filooServer + "customerplan/all-types")
        .then(function (response) {
          if (response.status === 200) {
            vm.plansType = response.data;
          }
        });
    },
    changeStatus(id, namePlan) {
      const vm = this;
      vm.axios
        .put(
          vm.$store.state.filooServer + "customerplan/change_status/" + id,
          {},
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.$swal(
              "Operação realizada!",
              "O status do plano <b style='color: #FF9F43; font-weight: 500'>" +
                namePlan +
                "</b> foi alterado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        });
    },
    seePlan(tr) {
      const vm = this;
      vm.showRowTypeCampaign = false;
      vm.titlePopupPlans = "Editar plano " + tr.name;
      vm.checkFalseInvalidFields();
      vm.checaEditando = false;
      vm.getPlan(tr.id);
    },
    addNewPlan() {
      const vm = this;
      vm.checaEditando = true;
      vm.checkFalseInvalidFields();
      vm.titlePopupPlans = "Adicionar novo plano";
      vm.plan = {};
      vm.isMultiple = false;
      vm.status = null;
      vm.active = null;
      vm.name = null;
      vm.description = null;
      vm.initialDate = null;
      vm.finalDate = null;
      vm.planValue = null;
      vm.code = null;
      vm.planIdIugu = null;
      vm.companyId = 2;
      vm.isCombo = false;
      vm.period = null;
      vm.method = null;
      vm.planTypeId = null;
      vm.discount = null;
      vm.options = null;
      vm.multPlanCode = null;
      vm.rootCampaign = null;
      vm.businessType = "B2C";
      vm.singleInstallment = 0;
      vm.licensingTax = 0;
      vm.nursingTax = 0;
      vm.initialDateFormated = null;
      vm.finalDateFormated = null;
      vm.showPagePlan = true;
      vm.showlistPlans = false;
      vm.showRowTypeCampaign = false;
      (vm.period = null),
        (vm.planType = null),
        (vm.method = null),
        (vm.company = null),
        (vm.isDefaultPlan = false);
      vm.freetrial = false;
      vm.amountDaysFreetrial = null;
    },
    checkFalseInvalidFields() {
      const vm = this;
      vm.saveClicked = false;
      vm.invalidFields = {
        name: false,
        description: false,
        initialDate: false,
        finalDate: false,
        planValue: false,
        code: false,
        planTypeId: false,
        businessType: false,
        planIdIugu: false,
        companyId: false,
        period: false,
        method: false,
        discount: false,
        options: false,
        rootCampaign: false,
        multPlanCode: false,
        isCombo: false,
        isDefaultPlan: false,
        freetrial: false,
        planPackage: false,
        amountDaysFreetrial: false,
      };
    },

    //CARREGA TELA PRINCIPAL
    getPlans() {
      const vm = this;
      this.axios
        .get(
          vm.$store.state.filooServer +
            "customerplan/find_by_partner_id?partnerId=" +
            vm.$route.params.id,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            const plans = response.data;
            vm.plans = response.data;
            vm.plans = plans.filter((p) => p.businessType == "B2C");
            vm.plansHistoric = vm.plans;
            vm.showlistPlans = true;
            vm.numPages = Math.ceil(vm.plans.length / 10);
            vm.pagination = vm.numPages > 1;
            vm.changePagination();
          }
        })
        .catch(function () {
          vm.$swal({
            title: "Atenção!",
            text: "Não foi possível listar os planos, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    dateFormatted(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    validateFields() {
      const vm = this;
      let invalid = false;
      const error = vm.invalidFields;
      vm.saveClicked = true;
      error.businessType = vm.testNullUndefinedEmpty(vm.businessType);
      error.name = vm.testNullUndefinedEmpty(vm.name);
      error.description = vm.testNullUndefinedEmpty(vm.description);
      vm.validateDates();
      error.planValue =
        vm.planValue !== 0 && vm.testNullUndefinedEmpty(vm.planValue);
      error.code = vm.testNullUndefinedEmpty(vm.code);
      error.planTypeId = vm.testNullUndefinedEmpty(vm.planType);
      error.period = vm.testNullUndefinedEmpty(vm.period);
      error.method = vm.testNullUndefinedEmpty(vm.method);
      error.planPackage =
        vm.testNullUndefinedEmpty(vm.planPackage) ||
        !vm.planPackage ||
        vm.planPackage == [];
      error.additionalLifeValue = vm.testNullUndefinedEmpty(
        vm.additionalLifeValue
      );

      invalid =
        error.businessType ||
        error.name ||
        error.description ||
        error.initialDate ||
        error.finalDate ||
        error.planValue ||
        error.code ||
        error.planTypeId ||
        error.period ||
        error.method ||
        error.planPackage ||
        error.additionalLifeValue;

      if (vm.businessType === "B2C") {
        error.discount = vm.testNullUndefinedEmpty(vm.discount);
        error.options = vm.testNullUndefinedEmpty(vm.options);
        error.companyId = vm.testNullUndefinedEmpty(vm.company);

        invalid = invalid || error.discount || error.options || error.companyId;
      }

      if (invalid) {
        vm.$vs.notify({
          title: "Atenção!",
          text: "Campos obrigatórios não preenchidos ou inválidos!",
          color: "warning",
          icon: "error_outline",
          position: "top-right",
        });
      } else {
        vm.testNullUndefinedEmpty(vm.plan.id)
          ? vm.saveNewPlan()
          : vm.updatePlan();
      }
    },
    saveNewPlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      let plan = {
        status: true,
        active: true,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId:
          vm.businessType == "B2B" ? vm.$route.params.id : vm.companyId,
        isCombo: vm.isCombo,
        period: vm.period.value,
        method: vm.method.value,
        planTypeId: vm.planTypeId,
        discount: vm.discount,
        options: vm.options,
        multPlanCode: vm.multPlanCode,
        rootCampaign: vm.rootCampaign,
        businessType: vm.businessType,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage: vm.planPackage,
        additionalLifeValue: parseFloat(
          vm.additionalLifeValue.replace(",", ".")
        ),
        isDefaultPlan: vm.isDefaultPlan,
        freetrial: vm.freetrial,
        amountDaysFreetrial: vm.amountDaysFreetrial,
        partnerId: vm.$route.params.id,
      };
      vm.axios
        .post(vm.$store.state.filooServer + "customerplan/", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.showPagePlan = false;
            vm.$swal(
              "Operação realizada!",
              "O plano <b style='color: #FF9F43; font-weight: 500'>" +
                plan.name +
                "</b> foi criado com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function (error) {
          if (error.response.status === 409) {
            vm.$swal(
              "Atenção!",
              "Já existe um plano associado a este identificador. Por favor verifique os dados e tente novamente ",
              "error"
            );
          } else {
            vm.showPagePlan = false;
            vm.showlistPlans = true;
            vm.$swal(
              "Atenção!",
              "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
              "error"
            );
          }
        });
    },
    updatePlan() {
      const vm = this;
      const stringPlanValue = vm.planValue.toString().replace(",", ".");
      console.log(
        vm.planPackage[0] == null ? vm.planPackage : vm.planPackage[0]
      );
      let plan = {
        id: vm.plan.id,
        status: vm.plan.status,
        active: vm.plan.status,
        name: vm.name,
        description: vm.description,
        initialDate: vm.initialDateFormated,
        finalDate: vm.finalDateFormated,
        planValue: stringPlanValue,
        code: vm.code,
        planId: vm.planIdIugu,
        companyId:
          vm.businessType == "B2B" ? vm.$route.params.id : vm.companyId,
        isCombo: vm.isCombo,
        period: vm.period.value,
        method: vm.method.value,
        planTypeId: vm.planTypeId,
        discount: vm.discount,
        options: vm.options,
        multPlanCode: vm.multPlanCode,
        rootCampaign: vm.rootCampaign,
        businessType: vm.businessType,
        singleInstallment: null,
        licensingTax: null,
        nursingTax: null,
        planPackage:
          vm.planPackage[0] == null ? vm.planPackage : vm.planPackage[0],
        additionalLifeValue: parseFloat(
          vm.additionalLifeValue.replace(",", ".")
        ),
        isDefaultPlan: vm.isDefaultPlan,
        freetrial: vm.freetrial,
        amountDaysFreetrial: vm.amountDaysFreetrial,
        partnerId: vm.$route.params.id,
      };
      console.log(plan);
      vm.axios
        .put(vm.$store.state.filooServer + "customerplan", plan, {
          headers: { Authorization: vm.$session.get("bearerDefault") },
        })
        .then(function (response) {
          if (response.status === 200) {
            vm.showPagePlan = false;
            vm.$swal(
              "Operação realizada!",
              "Os dados do plano <b style='color: #FF9F43; font-weight: 500'>" +
                vm.plan.name +
                "</b> foram alterados com sucesso.",
              "success"
            );
            vm.getPlans();
          }
        })
        .catch(function () {
          vm.showPagePlan = false;
          vm.showlistPlans = true;
          vm.$swal(
            "Atenção!",
            "Não foi possível realizar esta operação. Por favor contacte o administrador do sistema",
            "error"
          );
        });
    },
    //CARREGA TELA EDITAR
    getPlan(idPlan) {
      const vm = this;
      vm.axios
        .get(
          vm.$store.state.filooServer + "customerplan/find_by_id/" + idPlan,
          {
            headers: { Authorization: vm.$session.get("bearerDefault") },
          }
        )
        .then(function (response) {
          if (response.status === 200) {
            vm.plan = response.data;
            vm.fillPlan();
          }
        })
        .catch(function () {
          vm.showPagePlan = false;
          vm.$swal({
            title: "Atenção!",
            text: "Não foi possível localizar o plano selecionado, contacte o administrador do sistema.",
            icon: "error",
          });
        });
    },
    fillPlan() {
      const vm = this;
      vm.initialDateFormated = "";
      vm.finalDateFormated = "";
      if (vm.testNullUndefinedEmpty(vm.plan.initialDate) === false) {
        vm.initialDateFormated = moment(String(vm.plan.initialDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (vm.testNullUndefinedEmpty(vm.plan.finalDate) === false) {
        vm.finalDateFormated = moment(String(vm.plan.finalDate)).format(
          "YYYY-MM-DD"
        );
      }
      if (
        vm.testNullUndefinedEmpty(vm.plan.planValue) === false &&
        vm.plan.planValue != 0
      ) {
        let floatValue = parseFloat(vm.plan.planValue);
        let fixedValue = floatValue.toFixed(2);
        vm.planValue = fixedValue.toString().replace(".", ",");
      } else if (vm.plan.planValue == 0) {
        vm.planValue = vm.plan.planValue.toFixed(2);
      }
      vm.name = vm.plan.name;
      vm.active = vm.plan.active;
      vm.description = vm.plan.description;
      vm.code = vm.plan.code;
      vm.company = vm.companies.find((c) => {
        return c.id === vm.plan.companyId;
      });
      vm.planType = vm.plansType.find((p) => {
        return p.id === vm.plan.planTypeId;
      });
      vm.options = vm.plan.options;
      vm.period = vm.periods.find((p) => {
        return p.value === vm.plan.period;
      });
      vm.method = vm.methods.find((m) => {
        return m.value === vm.plan.method;
      });
      vm.rootCampaign = vm.plan.rootCampaign;
      vm.discount = vm.plan.discount;
      vm.multPlanCode = vm.plan.multPlanCode;
      vm.businessType = vm.plan.businessType;
      vm.isCombo = vm.plan.isCombo;
      vm.showPagePlan = true;
      vm.showlistPlans = false;
      vm.planIdIugu = vm.plan.planId;
      vm.planPackage = vm.planPackages.filter(
        (planPackage) => planPackage.id === vm.plan.planPackageId
      );
      vm.additionalLifeValue = vm.plan.additionalLifeValue.toFixed(2);
      vm.isDefaultPlan = vm.plan.isDefaultPlan;
      vm.freetrial = vm.plan.freetrial;
      vm.amountDaysFreetrial = vm.plan.amountDaysFreetrial;
    },
    dateFormattedUs(date) {
      let day = date.split("/")[0];
      let month = date.split("/")[1];
      let year = date.split("/")[2];
      return year + "-" + ("0" + month).slice(-2) + "-" + ("0" + day).slice(-2);
    },
    validateDates() {
      const vm = this;
      const isValid = vm.dateIsBeforeAnotherDate(
        vm.initialDateFormated,
        vm.finalDateFormated
      );
      vm.invalidFields.initialDate =
        !isValid || vm.testNullUndefinedEmpty(vm.initialDateFormated);
      vm.invalidFields.finalDate =
        !isValid || vm.testNullUndefinedEmpty(vm.finalDateFormated);
    },
    changePagination() {
      const vm = this;
      vm.plansPaginated = vm.plans.slice(
        (vm.currentx - 1) * 10,
        vm.currentx * 10
      );
    },
    handleResize() {
      const vm = this;
      vm.windowWidth = window.innerWidth;
    },
    getPlanPackages() {
      const vm = this;
      vm.axios
        .get(`${this.$store.state.filooServer}plan-package`, {
          headers: { Authorization: this.$session.get("bearerDefault") },
        })
        .then((res) => {
          if (res.status === 200) {
            vm.planPackages = res.data;
          }
        })
        .catch((err) => {
          console.log({
            endpointURL: "plan-package",
            error_getPlanPackages: err,
          });
        });
    },
    handleSearch(search) {
      const vm = this;
      vm.currentx = 1;
      if (vm.testNullUndefinedEmpty(search)) {
        vm.plans = vm.plansHistoric;
      } else {
        vm.plans = vm.plansHistoric.filter(
          (plan) =>
            plan.name.toLowerCase().includes(search.toLowerCase()) ||
            plan.code.toLowerCase().includes(search.toLowerCase()) ||
            (!vm.testNullUndefinedEmpty(plan.multPlanCode) &&
              plan.multPlanCode.toLowerCase().includes(search.toLowerCase()))
        );
      }
      vm.numPages = Math.ceil(vm.plans.length / 10);
      vm.pagination = vm.numPages > 1;
      vm.changePagination();
    },
  },
};
</script>

<style lang="scss" src="./PartnerPlans.scss"></style>
